export const siteInfo = {
  name: '瓜田笔记',
  slogan: '每日围观校园新鲜事',
  description:
    '记录高校吃瓜趣闻与日常，分享校园里的新鲜故事和见闻。从宿舍夜聊到课堂八卦，从社团趣事到食堂奇遇，每日更新真实经历，陪你围观大学生活的另一面。',
  email: 'hello@guatian-notes.com',
  contactWechat: 'guatian_notes',
  submitEmail: 'story@guatian-notes.com',
  startYear: 2021,
};

export const categories = [
  {
    slug: 'dorm',
    name: '宿舍夜聊',
    icon: 'ri-moon-clear-line',
    desc: '熄灯之后才是正片，宿舍里那些笑到打鸣的深夜话题。',
    color: 'primary',
  },
  {
    slug: 'class',
    name: '课堂八卦',
    icon: 'ri-book-2-line',
    desc: '点名、抢座、小组作业，教室里每天都在上演小型连续剧。',
    color: 'accent',
  },
  {
    slug: 'club',
    name: '社团趣事',
    icon: 'ri-team-line',
    desc: '百团大战到换届选举，社团里的高光和翻车现场。',
    color: 'secondary',
  },
  {
    slug: 'canteen',
    name: '食堂奇遇',
    icon: 'ri-restaurant-2-line',
    desc: '打饭阿姨的手抖学、隐藏菜单与食堂座位争夺战。',
    color: 'primary',
  },
  {
    slug: 'campus',
    name: '校园奇闻',
    icon: 'ri-compass-3-line',
    desc: '图书馆、操场、快递站……校园角落里意想不到的故事。',
    color: 'accent',
  },
];